export const FEED_GLOW_COLORS = {
    trending: "250,115,20",   // orange
    sport: "193,154,107",     // camel / brown
    following: "168,85,247",  // purple
};

// Header bg that bakes the same left→right color fade over the page dark, so a
// pinned sticky header keeps the fade at all times (blends with the section glow).
// Stops chosen so the colored extent matches the FeedGlow (w-2/5) behind the posts.
export const feedHeaderBg = (variant) => {
    const rgb = FEED_GLOW_COLORS[variant] || FEED_GLOW_COLORS.following;
    return `linear-gradient(to right, rgba(${rgb},0.34), rgba(${rgb},0.16) 15%, rgba(${rgb},0.04) 27%, transparent 34%), #0a0a0a`;
};

// Subtle left-edge color glow behind a feed section to signal its context.
export const FeedGlow = ({ variant, children, className = "" }) => {
    const rgb = FEED_GLOW_COLORS[variant] || FEED_GLOW_COLORS.following;
    return (
        <div className={`relative ${className}`} data-testid={`feed-glow-${variant}`}>
            <div
                aria-hidden
                className="pointer-events-none absolute -left-3 md:-left-4 -top-2 -bottom-2 w-2/5 z-0 rounded-r-3xl"
                style={{
                    background: `linear-gradient(to right, rgba(${rgb},0.34), rgba(${rgb},0.16) 40%, rgba(${rgb},0.04) 70%, transparent 85%)`,
                }}
            />
            <div className="relative z-10">{children}</div>
        </div>
    );
};
